if (!customElements.get('lumalux-video-stories')) {
  customElements.define('lumalux-video-stories', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.previewObserver?.disconnect();
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.rail = this.querySelector('.ll-stories__rail');
      this.items = [...this.querySelectorAll('[data-story]')];
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('.ll-stories__player');
      this.previews = [...this.querySelectorAll('[data-preview-source]')];
      this.visiblePreviews = new Set();
      this.previewMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.previewReady = document.readyState === 'complete';
      this.previewObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= .5) this.visiblePreviews.add(entry.target);
          else this.visiblePreviews.delete(entry.target);
        });
        this.updatePreviews();
      }, {threshold: [0, .5]});
      this.previews.forEach(video => {
        video.addEventListener('playing', () => video.classList.add('is-playing'), {signal});
        this.previewObserver.observe(video);
      });
      window.addEventListener('load', () => {
        this.previewReady = true;
        this.updatePreviews();
      }, {signal, once: true});
      document.addEventListener('visibilitychange', () => this.updatePreviews(), {signal});
      this.previewMotion.addEventListener('change', () => this.updatePreviews(), {signal});
      this.addEventListener('click', event => {
        const item = event.target.closest('[data-story]');
        const scroll = event.target.closest('[data-scroll]');
        const step = event.target.closest('[data-video-step]');
        if (item) this.openVideo(this.items.indexOf(item));
        if (scroll) this.rail.scrollBy({left: Number(scroll.dataset.scroll) * (getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1) * this.rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        if (step) this.openVideo((this.index + Number(step.dataset.videoStep) + this.items.length) % this.items.length);
        if (event.target.closest('[data-close]')) this.dialog.close();
      }, {signal});
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      }, {signal});
      this.dialog.addEventListener('close', () => {
        this.clearVideo();
        this.items[this.index]?.focus({preventScroll: true});
        this.updatePreviews();
      }, {signal});
      this.rail.addEventListener('scroll', () => this.updateArrows(), {signal, passive: true});
      this.observer = new ResizeObserver(() => this.updateArrows());
      this.observer.observe(this.rail);
      this.updateArrows();
    }
    updatePreviews() {
      this.previews.forEach(video => {
        const play = this.previewReady && !document.hidden && !this.dialog.open && !this.previewMotion.matches && this.visiblePreviews.has(video);
        if (play) {
          video.muted = true;
          if (!video.hasAttribute('src')) video.src = video.dataset.previewSource;
          if (video.paused) video.play().catch(() => {});
        } else {
          video.pause();
          if (this.previewMotion.matches) video.classList.remove('is-playing');
        }
      });
    }
    updateArrows() {
      const offset = Math.abs(this.rail.scrollLeft);
      this.querySelector('[data-scroll="-1"]').hidden = offset <= 2;
      this.querySelector('[data-scroll="1"]').hidden = offset >= this.rail.scrollWidth - this.rail.clientWidth - 2;
    }
    clearVideo() {
      const video = this.player.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        video.load();
      }
      this.player.replaceChildren();
    }
    openVideo(index) {
      this.clearVideo();
      this.index = index;
      this.player.append(this.items[index].querySelector('template').content.cloneNode(true));
      this.dialog.setAttribute('aria-label', this.items[index].getAttribute('aria-label'));
      if (!this.dialog.open) this.dialog.showModal();
      this.updatePreviews();
      this.player.querySelector('video').play().catch(() => {});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.previewObserver?.disconnect();
      this.previews?.forEach(video => video.pause());
      if (this.dialog?.open) this.dialog.close();
      if (this.player) this.clearVideo();
    }
  });
}
